// extracted by mini-css-extract-plugin
module.exports = {"searchArea":"CocomoniNew_searchArea_3iAio"};